module.exports = __webpack_public_path__ + "static/media/meta.4cbccbe5.png";